<template>
  <div>
    <v-container>
      <v-dialog
        v-model="isDialog"
        max-width="60vw"
      >
        <v-card
          v-show="true"
        >
          <v-alert type="info" outlined>
            <v-card-title>
              <span v-html="dialogHeader"></span>
            </v-card-title>
            <div>
              <v-card-text>
                <v-form ref="form"
                  class="my-form"
                >
                  <v-container :class="containerClass">
                    <v-row align="center"
                    >
                      <v-col cols="3">
                        <v-select
                          class="ImportInfoDialogFiscalYear"
                          id="import-info-dialog-fiscalYear"
                          v-model="input.fiscalYear"
                          :items="fiscalYearList"
                          item-text="name"
                          item-value="year"
                          label="By Fiscal Year"
                        ></v-select>
                      </v-col>
                      <v-col cols="3">
                        <ClarionDateControl
                          v-model="input.businessDate"
                          :isRequired="true"
                          :isIsoDate="true"
                          label="Business Date"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="importData"
                >
                Import
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="close"
                >
                Cancel
                </v-btn>
              </v-card-text>
            </div>
          </v-alert>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import {
  mapGetters,
  mapState,
  mapActions,
  mapMutations,
} from 'vuex';
import ClarionDateControl from '../../common/ClarionDateControl.vue';
import { queryStringCalc } from '../../Gl/Transaction/report-util';
import { getRawJwt } from '../../../util/jwt';
import { getFYList, toShortDate, getMaxFY } from '../../../util/shared/tmc-global';
import { getWorkstationNumber } from '../../../util/workstation-util';

export default {
  name: 'ImportInfo',
  components: {
    ClarionDateControl,
  },
  props: {
    closeDialogBox: {
      type: Boolean,
      default: false,
    },
    baseCrudKey: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    dialogHeader: 'Import Info',
    input: {
      fiscalYear: null,
      businessDate: '',
    },
  }),
  created() {
    this.initializeFiscalYears();
    this.initInputs();
  },
  computed: {
    ...mapGetters('user', ['getSettings']),
    ...mapGetters('base/crud', ['criteria']),
    ...mapState({
      mtgRegYears: (state) => state.mtg.mtgTransaction.regYears,
    }),
    ...mapGetters([
      'todaysDate',
    ]),
    isDialog: {
      get() {
        return this.closeDialogBox;
      },
      set(value) {
        this.$emit('settingDialogVal', value);
      },
    },
    queryString() {
      return queryStringCalc({
        criteria: this.criteria,
        token: this.getAuthToken,
      });
    },
    getAuthToken() {
      return getRawJwt();
    },
    fiscalYearList() {
      const registerdYears = (this.mtgRegYears || {});
      const fyList = getFYList(registerdYears);
      return fyList;
    },
    containerClass() {
      return this.getSettings.lightdark === 'light' ? 'grey lighten-5' : '';
    },
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
  },
  methods: {
    ...mapActions('mtg/mtgTransaction', [
      'copyTempMtgToMtgTrans',
      'flashError',
      'loadMtgTransaction',
    ]),
    ...mapMutations('base/crud', [
      'setCriteria',
    ]),
    close() {
      this.$emit('settingDialogVal', false);
    },
    async importData() {
      try {
        const { fiscalYear, businessDate } = this.input;
        const wkst = getWorkstationNumber() || '';
        const batchIDArr = await this.copyTempMtgToMtgTrans({ fiscalYear, businessDate, wkst });

        if (batchIDArr.length > 0) {
          this.$emit('closeDialogBox');
          this.criteriaState.batchIDArr = batchIDArr;
          this.$emit('handleLoadCRUDList');
          this.$emit('fetchAmountTotal', batchIDArr);
          this.isDialog = false;
        } else {
          console.error('Data import failed');
        }
      } catch (error) {
        console.error('Error occurred during data import', error);
        this.flashError('An unexpected error occurred during data import');
      }
    },
    initializeFiscalYears() {
      const maxFY = getMaxFY(this.fiscalYearList || []);
      this.input.fiscalYear = maxFY;
    },
    initInputs() {
      this.input.businessDate = toShortDate(this.todaysDate);
    },
  },
};
</script>

<style>
.my-form {
  border: 0.5px groove;
}
</style>
